import { render, staticRenderFns } from "./financeRecord.vue?vue&type=template&id=68d8dde9&scoped=true&"
import script from "./financeRecord.vue?vue&type=script&lang=js&"
export * from "./financeRecord.vue?vue&type=script&lang=js&"
import style0 from "./financeRecord.vue?vue&type=style&index=0&id=68d8dde9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8dde9",
  null
  
)

export default component.exports